import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import FAQ from './FAQ';

type Question = {
  question: string;
  answer: string;
};

type Props = {
  questions: Question[];
};

function FAQs({ questions }: Props): ReactElement {
  const seed = useUIDSeed();

  return (
    <div className="c-faqs">
      <div className="l-container">
        <h2 className="c-heading c-heading--brand-4 u-text--center">
          Frequently Asked Questions
        </h2>
        <br />
        {questions?.length > 0
        && questions.map(({ question, answer }, index) => (
          <FAQ
            key={seed(question)}
            expanded={index === 0}
            question={question}
            answer={answer}
          />
        ))}
      </div>
    </div>
  );
}

export default FAQs;
